<div class="w-100 wrapper-sezione-mappe">
    <div class="mappa-sensori-wrapper">
        <!-- Filtro sensori -->
        <div class="sensor-filter-container d-flex">
            <div class="w-100 d-flex flex-column justify-content-center pt-2">
                <!-- Tipi sensori -->
                <div class="form-floating d-flex align-items-center select-wrapper mr-2 mb-2">
                    <!-- <label for="select-tipo">Filtra tipo sensore</label> -->
                    <select class="custom-select" id="select-tipo" aria-label="Tipo sensore"
                        [(ngModel)]="selectedSensorType" (change)="onSensorTypeFilterChange()">
                        <option value="all" selected>Tutti i dati</option>
                        <option value="barometri">Pressione atmosferica</option>
                        <option value="idrometri">Livello idrometrico</option>
                        <option value="igrometri">Umidità relativa</option>
                        <option value="pluviometri">Precipitazione</option>
                        <option value="radiometri">Radiazione solare</option>
                        <option value="termometri">Temperatura</option>
                        <option value="ventoraffica">Velocità del Vento di Raffica</option>
                        <option value="ventoscalare">Velocità del Vento Media</option>
                    </select>
                </div>
                <div class="form-floating d-flex align-items-center select-wrapper mr-2 mb-2">
                    <ng-select class="border-form-cont w-100" [items]="stationListSelect" bindLabel="denominazione"
                        bindValue="idStazione" placeholder="Cerca stazione" [(ngModel)]="idStazioneSelect"
                        [searchable]="true" (change)="onStationFilterChange()">
                    </ng-select>
                </div>
                <div class="form-floating select-wrapper mr-2 w-100 d-flex justify-content-end" style="height: 30px;">
                    <button class="btn btn-danger m-0 h-100" (click)="showAllMarkers()">
                        <i class="fa fa-trash" aria-hidden="true"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="overlay-container">
            <!-- Elenco dei sensori -->
            <div *ngIf="sensorList.length > 0" class="card" style="margin-bottom: 0;">
                <div class="card-header header-sensori d-flex align-item-center justify-content-between">
                    <span style="font-size: 1rem;align-self: center">Elenco dei Sensori</span>
                    <button type="button" class="close-sensori close ml-2" (click)="closeSensorList()">
                        <span aria-hidden="true" style="font-size: 2.5rem; line-height: 1;">&times;</span>
                    </button>
                </div>
                <div class="sensor-list pb-2">
                    <ul class="list-group list-group-flush" style="overflow: auto !important;">
                        <li class="list-group-item"
                            style="cursor: pointer; padding-top: 5px !important; padding-bottom: 5px !important; min-height: 60px;"
                            *ngFor="let sensor of sensorList; let k = index;">
                            <div class="w-100 h-100 d-flex flex-column justify-content-center"
                                (click)="openSensorDetail(sensor.idSensore, sensor.tipoSensore, sensor.idTipoSensore)"
                                style="cursor: pointer;">
                                <div class="w-100">
                                    <span class="sensori-list">{{ sensor.idSensore || "" }} - {{sensor.nome ||
                                        ""}}</span>
                                </div>
                                <div class="w-100">
                                    <span class="sensori-tipo">{{getFriendlyName(sensor.tipoSensore) || ""}}</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- <div class="card-footer">
                    <span class="mb-2" style="font-size: 1rem;"><strong> </strong></span>
                </div> -->
            </div>
        </div>
        <!-- Mappa -->
        <div id="map"></div>
    </div>
</div>
<div class="disclaimer-container">
    <div class="w-100 d-flex justify-content-between px-4">
        <span class="w-25 h4">
            <span class="badge badge-secondary blink">Dati non validati</span>
        </span>
        <div class="d-flex align-items-center">
            <button class="btn btn-primary btn-lg mr-2" (click)="downloadExcelFile()">
                <i class="fa fa-file-excel mr-2" aria-hidden="true"></i>TABELLA SENSORI
            </button>
            <button class="btn btn-primary btn-lg" (click)="openPdfDocument()">
                <i class="fa fa-file-pdf mr-2" aria-hidden="true"></i>PDF
            </button>
        </div>
        <div class="switch-tabellare d-flex align-items-center my-2">
            <span class="pr-2">Visualizza tabella</span>
            <div class="pt-2">
                <bSwitch class="custom-switch pt-1" style="transform: scale(1.4);" [(ngModel)]="isTabella">
                </bSwitch>
            </div>
        </div>
    </div>
    <div *ngIf="isTabella" class="w-100 pt-2 pb-1 px-3">
        <!-- Controlli personalizzati per la paginazione -->
        <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="d-flex align-items-center">
                <label class="mr-2 mb-0">Righe per pagina:</label>
                <select class="form-control" style="width: auto;" [(ngModel)]="currentPageSize"
                    (change)="changePageSize(+$event.target.value)">
                    <option *ngFor="let size of pageSizeOptions" [value]="size">{{size}}</option>
                </select>
            </div>
            <div class="text-muted">
                Totale stazioni: {{dataTabella?.length || 0}}
            </div>
        </div>

        <!-- La tua tabella esistente -->
        <ag-grid-angular [rowData]="dataTabella" [gridOptions]="gridOptions" style="height: 600px; width: 100%;"
            class="ag-theme-alpine" [localeText]="customLocaleText">
        </ag-grid-angular>
    </div>
    <div class="container banner-container mb-4 w-100">
        <div class="banner-title"><i class="fa-solid fa-triangle-exclamation mr-1"
                style="color: #FFD43B;"></i>Avvertenza</div>
        <p class="banner-text">
            I dati forniti attraverso questo servizio, di proprietà esclusiva della Regione Campania, si riferiscono al
            valore puntuale della grandezza osservata. Essi NON sono stati sottoposti
            a tutte le fasi di validazione necessarie ai fini della pubblicazione ufficiale e, pertanto, potrebbero
            essere rettificati in fase di validazione definitiva.
            La Regione Campania è manlevata da qualsiasi conseguenza o responsabilità connessa all’uso non corretto o
            autorizzato dei dati, che resta sempre esclusivamente in capo al soggetto fruitore (utente del sito),
            indipendentemente da circostanze e/o finalità dell’uso.<br>

            Previa richiesta formale, da inviare via PEC all’indirizzo: <br>
            <i class="fa-solid fa-envelope mr-1" style="color: #74C0FC;"></i> <a
                href="mailto:dati.centrofunzionale@pec.regione.campania.it">dati.centrofunzionale@pec.regione.campania.it</a>,
            è possibile ottenere dati validati o certificati
            dall’Amministrazione.<br>
            Per informazioni, contattare lo 081-2323806 (Responsabile procedimenti: ing. Matteo Gentilella – <a
                href="mailto:matteo.gentilella@regione.campania.it">matteo.gentilella@regione.campania.it</a>)
            <br>
        </p>
        <!-- <a href="/**" class="banner-button text-white">Link alla pagina esterna<br>Dati validati</a> -->
        <div style="width: 100%; align-content: center; display: flex; justify-content: center;">
            <button class="btn btn-success btn-lg" disabled>Link alla pagina esterna<br>Dati validati</button>
        </div>
    </div>
</div>
<!-- <div class="table-wrapper">
    <h4>Elenco delle Stazioni</h4>
    <ag-grid-angular style="width: 100%; height: 500px;" class="ag-theme-alpine" [rowData]="stationList"
        [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" rowSelection="single"></ag-grid-angular>
</div> -->

<ng-template #theModalDetail let-modal let-c="close" let-d="dismiss">
    <!-- Loader -->
    <div *ngIf="isLoadingSensorDetail"
        class="h-100 w-100 d-flex align-items-center justify-content-center img-map-livelli-container">
        <div style="width:100%; margin-top: 100px; margin-bottom: 100px; text-align:center;">
            <div class="loader">
                <div class="outer"></div>
                <div class="middle"></div>
                <div class="inner"></div>
            </div>
        </div>
    </div>
    <!-- Dettaglio -->
    <div *ngIf="!isLoadingSensorDetail" class="w-100">
        <div class="border-bottom p-3 d-flex justify-content-between align-items-center">
            <div class="h-100 d-flex align-items-center">
                <span class="h5 m-0" style="float: left; text-transform: uppercase;">
                    DETTAGLIO SENSORE {{selectedSensorDetail.nome}} - COD.{{ selectedSensorIdDetail }} ({{
                    tipoSensoreFriendlyName || "" }})

                </span>
            </div>
            <button type="button" class="close" (click)="closeSingleModal(modal)">
                <span aria-hidden="true" style="font-size: 3rem; line-height: 1;">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div style="width: 100%; text-align: center; font-style: italic;">
                <div class="d-flex">
                    <div class="d-flex">
                        Ultimo aggiornamento ora solare (UTC+1h): &nbsp; <strong> {{ultimoAggiornamento}}</strong>
                    </div>
                </div>
            </div>
            <app-sensor-chart [datiSensore]="selectedSensorDetail?.dati" [tipoSensoreId]="tipoSensoreToModal">
            </app-sensor-chart>
        </div>

        <div class="pt-3 modal-footer d-flex justify-content-end">
            <button class="btn btn-info mr-2"
                (click)="esportaCSVtoFile(selectedSensorDetail.id, selectedSensorDetail.tipoId)">
                <span class="h5 m-1">Download CSV</span>
            </button>
            <button class="btn btn-danger" (click)="closeSingleModal(modal)">
                <span class="h5 m-1">Chiudi</span>
            </button>
        </div>
    </div>
</ng-template>

<ng-template #theModalSensori let-modal let-c="close" let-d="dismiss">
    <div class="border-bottom p-3 d-flex justify-content-between align-items-center">
        <span class="h4 m-0" style="float: left; margin-top: 10px;text-transform: uppercase;">
            DETTAGLIO STAZIONE {{ stazioneSelezionata.denominazione }} - {{stazioneSelezionata.comune || ""}} ({{
            stazioneSelezionata.provincia ? stazioneSelezionata.provincia : ""}})

        </span>
        <button type="button" class="close" (click)="closeSingleModal(modal)">
            <span aria-hidden="true" style="font-size: 3rem; line-height: 1;">&times;</span>
        </button>
    </div>

    <div class="modal-body">

        <div class="sensor-list" *ngIf="sensoriToDettaglioTabella.length > 0;">
            <ag-grid-angular [rowData]="sensoriToDettaglioTabella" [gridOptions]="gridOptionsSensori"
                style="height: 600px; width: 100%;" class="ag-theme-alpine" [localeText]="customLocaleText">
            </ag-grid-angular>
        </div>
        <div *ngIf="sensoriToDettaglioTabella.length == 0;" class="card">
            <div class="card-header">
                <span class="mb-2" style="font-size: 1rem;">Elenco dei Sensori</span>
            </div>
            <div class="sensor-list" style="min-height: 50px; max-height: 450px;">
                <span>Non sono stati trovati sensori associati a questa stazione</span>
            </div>
            <!-- <div class="card-footer">
                <span class="mb-2" style="font-size: 1rem;"><strong> </strong></span>
            </div> -->
        </div>

    </div>

    <div class="pt-3 modal-footer d-flex justify-content-end">
        <button class="btn btn-danger" (click)="closeSingleModal(modal)">
            <span class="h5 m-1">Chiudi</span>
        </button>
    </div>
</ng-template>